export default "__VITE_ASSET__c50088d0__"